module.exports = __webpack_public_path__ + "static/reflections-462d935262d83faa8f300171cf243cf4.png";